<template>
  <a href="javascript:void(0)"  @click.prevent="() => clickFn()" :aria-label="groupTitle(cellInfo)">
    <div aria-hidden="true" class="inner-wrap">
      <div class="picture-area">

        <template v-if="cellInfo.thumbnail">
          <WebpImage :image-info="{imageUrl: cellInfo.thumbnail, width: thumbnailInfo.width, height: thumbnailInfo.height, alt: cellInfo.alt}" />
          <ul class="badge-list">
            <li class="left-top-area">
              <ul v-top-tag-list="{ badgeList: topTagList(cellInfo), badgeType: 'artwork' }" />
            </li>
            <li class="right-top-area" v-common-tag-list="{'badgeList': brandTagList(cellInfo), 'type': 'brand'}" />
          </ul>
        </template>

        <template v-else>
          <div class="alt-title">
            <span>{{ groupTitle(cellInfo) }}</span>
          </div>
        </template>

      </div>
      <div class="cell-info">
        <div class="cell-title-wrap" >
          <div
            v-for="(text, index) in titleList(cellInfo)"
            :key="`title_${index}`"
            class="cell-title"
          >
            <span :class="[`title${index+1}`, 'line1']" v-html="text" />
          </div>
          <p class="cell-synopsis" v-html="cellInfo.synopsis" />
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import { commonTagList, topTagList } from '@/common/directives'
import { resizeThumbnail } from '@/common/image.filter'
import { get } from 'lodash'
import WebpImage from '@/components/image/WebpImage'

export default {
  name: 'SeriesPortraitCell',
  components: { WebpImage },
  // for movie series
  props: {
    cellInfo: {
      type: Object,
      default: () => {}
    },
    thumbnailInfo: {
      type: Object,
      default: () => {}
    }
  },
  directives: {
    topTagList,
    commonTagList
  },
  methods: {
    clickFn () {
      this.$emit('click-fn')
    },
    getThumbnailImg (cell) {
      return resizeThumbnail(cell.thumbnail, this.thumbnailInfo)
    },
    brandTagList (cell) {
      return get(cell, 'brand_taglist', [])
    },
    topTagList (cell) {
      return get(cell, 'top_taglist', []).concat(get(cell, 'bottom_taglist', []))
    },
    groupTitle (cell) {
      return get(cell, 'grouptitle', '')
    },
    titleList (cell) {
      const titleList = get(cell, 'title_list', [])
      const [ titleMain, titleSub ] = titleList
      const title = get(titleMain, 'text', '')
      const subTitle = get(titleSub, 'text', '').replace('$O$', '<i class="icon-dotted"></i>')
      return [ title, subTitle ]
    }
  }
}
</script>
